import type { ReactNode } from "react";
import {
  DepsProvider,
  StoresProvider,
  type Deps,
  type Stores,
} from "@repo/share-log-ui/context";
import { ToastProvider } from "@repo/share-log-ui/services/toast";
import { ModalProvider } from "@repo/share-log-ui/services/modal";

interface AppProvidersProps {
  stores: Stores;
  deps: Deps;
  children: ReactNode;
}

/** 공유 UI가 쓰는 store/api/logger를 주입한다. `main.tsx`가 앱 싱글턴을 넣는다 */
export function AppProviders({ stores, deps, children }: AppProvidersProps) {
  return (
    <DepsProvider deps={deps}>
      <StoresProvider stores={stores}>{children}</StoresProvider>
    </DepsProvider>
  );
}

/** 앱 전역 토스트·모달 표시 영역 */
export function AppOverlays() {
  return (
    <>
      <ToastProvider />
      <ModalProvider />
    </>
  );
}
